// hooks/useFetchGroupLeaders.ts
import { useEffect, useState, useCallback } from 'react';
import { getAPI } from '../services/api.service';
import { toast } from 'react-toastify';

interface Leader {
  id?: string;
  _id?: string;
  firstname?: string;
  lastname?: string;
  email?: string;
  groups?: Array<{ id?: string; title?: string }>;
}

export const useFetchGroupLeaders = () => {
  const [leaders, setLeaders] = useState<Leader[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLeaders = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAPI<{message:string, data: Leader[]}>('groups/leaders');
      // Expecting response shape: { status: 200, data: [ ... ], ... }
      if (res?.status === 200) {
        const payload = res.data?.data ?? res.data ?? [];
        setLeaders(Array.isArray(payload) ? payload : []);
      } else {
        setError('Failed to fetch group leaders');
        toast.error(res?.data?.message || 'Failed to fetch group leaders');
      }
    } catch (err: any) {
      console.error('fetch group leaders error', err);
      setError('An error occurred while fetching group leaders');
      toast.error(err?.response?.data?.message || 'Failed to fetch group leaders');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLeaders();
  }, [fetchLeaders]);

  return { leaders, loading, error, refetch: fetchLeaders };
};
